module.exports = __webpack_public_path__ + "img/four-times.084a3fab.png";